import {
    setCookie,
    initializeMap,
    initMenuTrigger,
    initOpenInNewTab,
    //aosConfig,
    addScollClass,
    addFancyboxFixForGallery,
    initGallerySlider,
    addCloseCookies,
    initForm,
    googleMapInit,
    initLoadNews,
    faqService,
    initLazyBg,
    initShow
} from './functions';


//import gsap from "gsap";


const mainApp = () => {

    // init lazy loading backgrounds width .lazyBg
    initLazyBg();

    initShow();

    // init menu trigger
    initMenuTrigger();

    // init open in new tab
    initOpenInNewTab();

    // init AOS animation config
    // aosConfig();

    // add scroll class to body  
    addScollClass('100px', 'scroll');



    //fix gallery id for slideshow
    addFancyboxFixForGallery('.wp-block-gallery');

    //gallerySlider
    initGallerySlider();

    // add close function to cookies
    addCloseCookies();



    //start - contact form
    initForm();

    googleMapInit();


    initLoadNews();

    faqService();




}

document.addEventListener("DOMContentLoaded", mainApp, false);


(function ($) {
    const mainAppWithJquery = () => {


        $('.subpageHeader__goDown').click(function () {
            $('html,body').animate({ 'scrollTop': ($(this).offset().top - $(this).height()) + 'px' }, 500);
        });

        $('.menu-item-has-children').on('click', function (e) {
            e.stopPropagation();
            if (!$(this).hasClass('active')) {
                $(this).addClass('active');
            } else {
                $(this).removeClass('active');
            }
        });

        $('.singleApartment__calendarTrigger, .singleApartment__calendarPopupClose').on('click', function () {
            document.body.classList.toggle('showCalendarPopup');
        });


        let filters = document.querySelectorAll('.propertyFilter__itemInput input');
        if (filters) {
            [...filters].forEach((item) => {

                item.addEventListener('focus', e => e.target.parentNode.querySelector(':scope label').classList.add('active'));
                item.addEventListener('focusout', e => {
                    if (e.target.value == '' || e.target.value == null) {
                        e.target.parentNode.querySelector(':scope label').classList.remove('active');
                    } else {
                        e.target.parentNode.querySelector(':scope label').classList.add('active');
                    }
                });
                item.dispatchEvent(new CustomEvent('focusout'));
            });

        }
        $('.propertyFilter__optionLabel.all').on('click', function () {
            $(this).parents('.propertyFilter__options').find('input').each(function () {
                this.checked = false;
            });
            $('.propertyFilter__accept').click();
        });

        $('.propertyFilter__checkbox').on('change', function () {
            $('.propertyFilter__accept').click();
        });







        //rotator and sliders
        if ($('.gAtra__slider').length > 0) {
            $('.gAtra__slider').slick({
                infinite: true,
                arrows: true,
                dots: false,
                autoplay: false,
                speed: 500,
                autoplaySpeed: 3000,
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1660,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });

        }
        if ($('.gApartments__slider').length > 0) {
            $('.gApartments__slider').slick({
                infinite: true,
                arrows: true,
                dots: false,
                autoplay: false,
                speed: 500,
                autoplaySpeed: 3000,
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 860,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 560,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });

        }



        //fancybox
        const fcbChck = document.querySelectorAll(".blocks-gallery-item a, .fancybox, .wp-block-image a[href$='.jpg'], .wp-block-image a[href$='.jpeg'], .wp-block-image a[href$='.png'], .wp-block-image.fancybox a");

        if (fcbChck.length > 0) {
            let scriptF = document.createElement("script");
            scriptF.setAttribute("src", window.location.origin + "/wp-content/themes/anatour/plugins/fancybox/jquery.fancybox.min.js");
            document.body.appendChild(scriptF);
            let cssF = document.createElement("link");
            cssF.setAttribute("rel", 'stylesheet');
            cssF.setAttribute("href", window.location.origin + "/wp-content/themes/anatour/plugins/fancybox/jquery.fancybox.min.css");
            document.body.appendChild(cssF);

            scriptF.addEventListener("load", () => {

                $(".blocks-gallery-item a, .fancybox, .wp-block-image a[href$='.jpg'], .wp-block-image a[href$='.jpeg'], .wp-block-image a[href$='.png'], .wp-block-image.fancybox a").fancybox({
                    'loop': true,
                    'margin': [44, 0],
                    'gutter': 50,
                    'keyboard': true,
                    'arrows': true,
                    'infobar': false,
                    'toolbar': true,
                    'buttons': ["slideShow", "fullScreen", "close"],
                    'idleTime': 4,
                    'protect': false,
                    'modal': false,
                    'animationEffect': "fade",
                    'animationDuration': 600,
                    'transitionEffect': "fade",
                    'transitionDuration': 800,
                    backFocus: false,
                    thumbs: {
                        autoStart: true, // Display thumbnails on opening
                        hideOnClose: true, // Hide thumbnail grid when closing animation starts
                        parentEl: ".fancybox-container", // Container is injected into this element
                        axis: window.innerWidth > 782 ? "y" : "x" // Vertical (y) or horizontal (x) scrolling
                    }
                });
            });

        }


        $('body *[href*="*!*"]').each(function () {
            $(this).attr('href', $(this).attr('href').replace('*!*', '@'));
        });

        $('body').find(":contains('*!*'):not(:has(*))").each(function () {
            $(this).html($(this).html().replace(/\*!\*/gim, '@'));
        });



    };
    document.addEventListener("DOMContentLoaded", mainAppWithJquery, false);

})(jQuery);




